import { render } from "./SelectInput.vue?vue&type=template&id=2a0a2c10"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=2a0a2c10&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__